<template>
  <div class="step-3">
    <p v-html="firstParagraphe">
    </p>
    <p>
      {{ getStepText('secondParagraphe', {
        btnName: getStepText('sign'),
      }) }}
    </p>
    <el-button
      @click="shortCutClick"
      class="step-3--button"
      :disabled="isFinished"
      type="success">
      {{ getStepText('sign') }}
    </el-button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import offersHelper from '@/utils/helpers/offers';
import StepWrapper from '@/components/procedures/prebookStepper/steps/StepWrapper.vue';

export default {
  name: 'step3',
  extends: StepWrapper,
  computed: {
    isFinishedState() {
      return offersHelper.isFinishedState(this.offersStore);
    },
    isFinished() {
      return offersHelper.isFinished(this.offersStore);
    },
    validedOffer() {
      return offersHelper.getValidOffer(
        this.offersStore,
        this.isIndividual || !this.isValidationDoneByPartner,
      );
    },
    price() {
      return offersHelper.getPrice(this.validedOffer);
    },
    firstParagraphe() {
      return this.getStepText('firstParagraphe', {
        price: this.$n(this.price, 'currency'),
        name: this.validedOffer.mover.name,
      });
    },
  },
  methods: {
    ...mapActions({
      displaySigning: 'comparatorStore/displaySigningModal',
    }),
    shortCutClick() {
      this.$store.dispatch('actionsStore/track', 'topBook');
      if (this.isFinishedState) {
        this.displaySigning(this.validedOffer);
        return;
      }
      this.$router.push({
        name: 'booking',
        params: {
          id: this.validedOffer.id,
        },
        hash: '#resume',
      });
    },
  },
};
</script>

<style lang="scss" scoped>

  .step-3 {
    &--button {
      margin-top: 10px;
    }
  }
</style>
